import React from "react";
import { Outlet } from "react-router-dom";

import AppHeader from "./AppHeader";
import AppSidebar from "./AppSidebar";

import "./AppLayout.scss";

const AppLayout = () => (
  <div className="app-layout">
    <AppHeader />
    <div className="app-body">
      <AppSidebar />
      <main className="app-content">
        <Outlet />
      </main>
    </div>
  </div>
);

export default AppLayout;
